"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_UNSAVED_CHANGES = exports.UPDATE_PAGE_EDITOR_STATE = exports.SET_PAGE_LOADING_ERROR = exports.SAVE_PAGE = exports.RENAME_PAGE = exports.PAGE_PATH_CHANGED = exports.FETCH_VERSIONS_SUCCESS = exports.FETCH_PAGE_MD_SUCCESS = exports.FETCH_PAGE_HTML_SUCCESS = exports.DELETE_PAGE = exports.CREATE_PAGE = void 0;
var _actionify = require("@mulesoft/actionify");
// eslint-disable-next-line import/no-extraneous-dependencies

var FETCH_PAGE_HTML_SUCCESS = exports.FETCH_PAGE_HTML_SUCCESS = 'Fetch Page HTML Success';
var FETCH_PAGE_MD_SUCCESS = exports.FETCH_PAGE_MD_SUCCESS = 'Fetch Page Markdown Success';
var FETCH_VERSIONS_SUCCESS = exports.FETCH_VERSIONS_SUCCESS = 'Fetch Versions Success';
var CREATE_PAGE = exports.CREATE_PAGE = (0, _actionify.buildActionsFor)('Create Page');
var DELETE_PAGE = exports.DELETE_PAGE = (0, _actionify.buildActionsFor)('Delete Page');
var RENAME_PAGE = exports.RENAME_PAGE = (0, _actionify.buildActionsFor)('Rename Page');
var SAVE_PAGE = exports.SAVE_PAGE = (0, _actionify.buildActionsFor)('Save Page');
var UPDATE_UNSAVED_CHANGES = exports.UPDATE_UNSAVED_CHANGES = 'Update Unsaved Changes';
var PAGE_PATH_CHANGED = exports.PAGE_PATH_CHANGED = 'Page Path Changed';
var UPDATE_PAGE_EDITOR_STATE = exports.UPDATE_PAGE_EDITOR_STATE = 'Update Page Editor State';
var SET_PAGE_LOADING_ERROR = exports.SET_PAGE_LOADING_ERROR = 'Set Page Loading Error';
//# sourceMappingURL=actionTypes.js.map